interface Props {
    className?: string
    FillColor?: string
}

export default function Clock({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
            <path
                d="M12.45 6C12.6157 6 12.75 6.13431 12.75 6.3L12.75 11.6894L14.8674 13.8068C15.3361 14.2755 15.3361 15.0353 14.8674 15.5039C14.7503 15.6211 14.5603 15.6211 14.4432 15.5039L11.4853 12.5461L11.4763 12.5369C11.3367 12.4007 11.25 12.2105 11.25 12V7.2C11.25 6.53726 11.7873 6 12.45 6Z"
                fill={FillColor} />
            <path
                d="M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
                fill={FillColor} />
        </svg>
    )
}
